module.exports = __webpack_public_path__ + "img/penalty-yellow.f29f3786.svg";